<div [formGroup]="form" *ngIf="isVisible">
  <div class="row mb-3">
    <div class="col-lg-6">
      <file-uploader
        [maxSize]="1024 * 5"
        [allowedTypes]="['png', 'jpg', 'jpeg']"
        class="w-100"
        data-testid="support-selfie-input"
        (select)="onFileSelect($event, 'personalPhoto')"
        (remove)="onFileRemove('personalPhoto')"
      >
        <input
          #file
          (click)="markAsTouched('personalPhoto')"
          type="file"
          class="input"
          required
        />
        <ng-template #placeholder>
          <img
            src="assets/images/icons/upload-selfie.svg"
            alt="upload image icon"
          />
          <div
            class="text-primary pt-2 text-sm"
            i18n="@@support.selfie.label"
          >
            Selfie *
          </div>
        </ng-template>
      </file-uploader>
      <small
        i18n="@@support.required"
        class="text-danger"
        *ngIf="
          form.get('personalPhoto').errors?.required &&
          form.get('personalPhoto').touched
        "
        >* This field is required.</small
      >
    </div>
    <div class="col-lg-6">
      <file-uploader
        [maxSize]="1024 * 5"
        [allowedTypes]="['png', 'jpg', 'jpeg']"
        data-testid="support-passport-input"
        class="w-100"
        (select)="onFileSelect($event, 'passport')"
        (remove)="onFileRemove('passport')"
      >
        <input
          #file
          type="file"
          class="input"
          required
          (click)="markAsTouched('passport')"
        />
        <ng-template #placeholder>
          <img src="assets/images/icons/upload-passport.svg" alt="upload icon" />
          <div
            class="text-primary pt-2 text-sm"
            i18n="@@support.otpTicket.passportOrID"
          >
            Passport or ID *
          </div>
        </ng-template>
      </file-uploader>
      <small
        i18n="@@support.required"
        class="text-danger"
        *ngIf="
          form.get('passport').errors?.required && form.get('passport').touched
        "
        >* This field is required.</small
      >
    </div>
  </div>

  <form-field
    class="front textarea"
    label="Ticket Message"
    i18n-label="@@support.message.label"
  >
    <textarea
      formControlName="message"
      data-testid="support-ticketMessage-txtField"
      placeholder="Enter your ticket message"
      rows="5"
      i18n-placeholder="@@support.message.placeholder"
    ></textarea>
  </form-field>
</div>
